import React from "react";
import { Box, Typography } from "@mui/material";

const OrderReceipt = ({ order }) => {
  const orderDate = order?.updatedAt
    ? new Date(order.updatedAt).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "N/A";

  const PropertyRow = ({ label, value }) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mb: 0.5,
        "& > :last-child": { ml: 1.5 },
      }}
    >
      <Typography
        sx={{
          fontWeight: "bold",
          color: "text.secondary",
          mr: 1,
          fontSize: 12,
          minWidth: 80,
        }}
      >
        {label}
      </Typography>
      <Typography sx={{ color: "text.secondary", fontSize: 12 }}>
        {value}
      </Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        p: 2,
        maxHeight: 250,
        minWidth: "80%",
        overflow: "hidden",
        borderRadius: 1,
      }}
    >
      <Typography
        sx={{
          fontWeight: "bold",
          color: "primary.main",
          mb: 1,
          fontSize: 14,
        }}
      >
        Order Details
      </Typography>

      <PropertyRow
        label="Order Id"
        value={order?.orderId ?? order?.id ?? "N/A"}
      />
      <PropertyRow label="Order Date" value={orderDate} />
      <PropertyRow label="Order Status" value={order?.status ?? "N/A"} />
      <PropertyRow
        label="Assigned To"
        value={order?.staff?.fullName ?? "N/A"}
      />
    </Box>
  );
};

export default OrderReceipt;
